import { render, staticRenderFns } from "./communityActivityDetail.vue?vue&type=template&id=15dc18ba&scoped=true"
import script from "./communityActivityDetail.vue?vue&type=script&lang=js"
export * from "./communityActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./communityActivityDetail.vue?vue&type=style&index=0&id=15dc18ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc18ba",
  null
  
)

export default component.exports